import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import type { NonGenerativeAIAnswerResultShownProps } from './types';

// since some experiences don't have a plain text answer (e.g. Jira Issue Knowledge Card)
export const onNonGenerativeAIAnswerResultShown: ({
	searchSessionId,
	queryHash,
	brand,
	source,
	query,
	answerString,
	answerCardType,
	fmpLoadTime,
	resourceType,
}: NonGenerativeAIAnswerResultShownProps) => AnalyticsEventPayload = ({
	searchSessionId,
	queryHash,
	brand,
	source,
	query,
	answerString,
	answerCardType,
	fmpLoadTime,
	resourceType,
}: NonGenerativeAIAnswerResultShownProps): AnalyticsEventPayload => {
	return {
		action: 'shown',
		actionSubject: 'aiAnswerResult',
		source: source,
		eventType: 'track',
		attributes: {
			searchSessionId,
			queryHash,
			brand,
			source,
			answerCardType,
			fmpLoadTime,
			resourceType,
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
		},
	};
};
